// extracted by mini-css-extract-plugin
export var hidden = "_pb-1";
export var visible = "_pb-0";